import { HasKind } from '@/utilities/HasKind';

export const kind = 'WipeComplete';

export type WipeComplete = HasKind<typeof kind>;

export const wipeComplete: WipeComplete = { kind };
